/* stylelint-disable selector-no-qualifying-type */
/* stylelint-disable max-nesting-depth */

/**
* @prop --uic-list-popover-max-height: The maximum height of the list.
* @prop --uic-list-popover-max-width: The maximum width of the list.
* @prop --uic-list-popover-width: The width of the list.
* @prop --uic-list-popover-min-width-offset: A number that gets subtracted from the popovers trigger width to calculate the final min-width of the popover.
* @prop --uic-dropdown-variant-content-max-width: The maximum width of the dropdown.
* @prop --uic-dropdown-variant-content-min-width: The minimum width of the dropdown.
*/

:host {
    @include form-control();
    display: inline-block;
    box-sizing: border-box;
    position: relative;

    .uic-dropdown {
        &__scroller {
            max-height: var(--uic-list-popover-max-height);
            max-width: var(--uic-list-popover-max-width);
            width: var(--uic-list-popover-width, auto);
        }

        &__button {
            display: flex;
            align-items: center;
            cursor: pointer;
            gap: 8px;
            width: 100%;
            padding: 0 8px;
            text-align: left;
            font-weight: var(--uic-font-weight-semibold);
            font-family: var(--uic-font-family);
        }

        &__label {
            @include font(normal, normal);
            @include truncate();
            display: block;
            color: var(--uic-color-black);
        }

        &__value {
            flex: 1;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &--placeholder {
                font-weight: var(--uic-font-weight-normal);
                color: var(--uic-color-grey3a50);
            }
        }

        &__chevron {
            --uic-icon-width: var(--uic-icon-dimensions-default);
            --uic-icon-height: var(--uic-icon-dimensions-default);
            color: var(--uic-color-grey3);
        }
    }
}

:host(.uic-dropdown--open) {
    .uic-dropdown {
        &__button {
            box-shadow: none;
        }

        &__chevron {
            transform: rotate(180deg);
        }
    }
}

:host(.uic-dropdown--disabled) {
    pointer-events: none;

    .uic-dropdown__chevron {
        color: var(--uic-color-grey5);
    }
}

:host(.uic-dropdown--variant-content) {
    --uic-list-popover-min-width-offset: 16;

    max-width: var(--uic-dropdown-variant-content-max-width);
    min-width: var(--uic-dropdown-variant-content-min-width);

    .uic-dropdown {
        &__value {
            @include font(medium);
        }

        &__button {
            @include atom();
            height: var(--uic-dim-height);
            padding-right: 20px;

            &:active .uic-dropdown__chevron,
            &:hover .uic-dropdown__chevron,
            &:active .uic-dropdown__chevron {
                color: inherit;
            }
        }
    }
}

:host(.uic-dropdown--variant-header),
:host(.uic-dropdown--variant-header-icon-only),
:host(.uic-dropdown--variant-header-icon-button) {
    .uic-dropdown__scroller {
        width: var(--uic-list-popover-width, 200px);
    }

    .uic-dropdown__label {
        padding-bottom: 2px;
    }

    .uic-dropdown__value {
        line-height: var(--uic-line-height-normal);
        font-size: var(--uic-font-size-normal);
    }

    .uic-dropdown__button {
        border: 0;
        padding: 13px 8px 11px;
        background: var(--uic-color-white);
        outline: 2px solid transparent;
        outline-offset: -2px;

        @include focus-visible-outline() {
            outline-color: var(--uic-color-blue2);
        }

        &:active .uic-dropdown__value,
        &:active .uic-dropdown__chevron,
        &:hover .uic-dropdown__value,
        &:hover .uic-dropdown__chevron {
            color: var(--uic-color-blue3);
        }

        &:disabled .uic-dropdown__value,
        &:disabled .uic-dropdown__chevron {
            color: var(--uic-color-grey5);
        }
    }
}

:host(.uic-dropdown--variant-header-icon-only) {
    .uic-dropdown__button {
        color: var(--uic-color-grey3);

        &:hover {
            color: var(--uic-color-blue3);
        }

        &:active {
            color: var(--uic-color-blue3);
        }

        &:disabled {
            color: var(--uic-color-grey3a50);
        }

        &:active .uic-dropdown__chevron,
        &:hover .uic-dropdown__chevron {
            color: inherit;
        }
    }
}

:host(.uic-dropdown--variant-header-icon-button) {
    .uic-dropdown__button {
        @include atom();
        color: var(--uic-color-grey3);
        padding: 13px 8px 11px;

        &:active .uic-dropdown__chevron,
        &:hover .uic-dropdown__chevron {
            color: inherit;
        }
    }
}
